import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { path } from 'ramda';
import { RecurringPaymentsStoreService } from '@modules/recurring-payments/services/recurring-payments-store.service';

@Injectable({
    providedIn: 'root',
})
export class DisaffiliationFormGuard implements CanActivate {
    constructor(private router: Router, private _recurringPaymentStore: RecurringPaymentsStoreService) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const isAffiliated = path(
            ['userAffiliation', 'isAffiliated'],
            this._recurringPaymentStore.recurrentPaymentState
        );
        if (isAffiliated) return true;

        this.router.navigate(['/recurring-payments']);
        return false;
    }
}
